import VueMask from 'v-mask'
import mask from '../functions/mask'


export default ({ app, router, Vue }) => {
	Vue.use(VueMask)
	Vue.prototype.$mask = mask
}
